import Backbone from '@polleverywhere/backbone'
import { slice as appSlice } from '../../slices/app'
import store from '@polleverywhere/redux'

// Ensure all .../web and .../intro routes are moved to .../respond
function replaceLegacyWithRespond (type, participantKey) {
  if (/\/web|\/intro/.test(Backbone.history.fragment)) {
    this.navigate(`${type}/${participantKey}/respond`, {
      trigger: false,
      replace: true
    })
  }
}

/**
 * Updates URL when state changes. Also, update the state model
 * from the initial route.
 */
export default class Router extends Backbone.Router {
  get routes () {
    return {
      blank: 'blank',
      // *args here handles all the weird crap that embedders like facebook append to the URL
      ':type/:participant_key/(respond|web|intro)*args': (type, key) => {
        replaceLegacyWithRespond.call(this, type, key)
        this.state.showIndividualActivity(type, key)
      },

      ':presenter/register': (presenter) => {
        this.state.enterRegisterFlow(presenter)
      },
      ':presenter': (presenter) => {
        this.state.joinPresenterSession(presenter)
      }
    }
  }

  initialize ({ state, updateURL = true } = {}) {
    this.state = state

    // Update route based on state changes
    if (updateURL) {
      // If we hit a named route, update the url. e.g. settings, login, etc.
      this.on('route', (route, params) => {
        if (route.length) {
          store.dispatch(appSlice.pageUpdated(route))
        }
      })
    }
  }
}
